<div class="drawer"
     [class.open]="drawerOpen"
     [attr.aria-hidden]="!drawerOpen ? 'true' : null">
  <div class="drawer-title-bar">
    <div class="drawer-title-left">
      <app-euds-button
                       type="plain"
                       [ariaLabel]="drawerOpen ? 'Close Side Panel' : 'Open Side Panel'"
                       icon="feather/x"
                       (clickEvent)="closeDrawer($event)">
      </app-euds-button>
      <h4 class="drawer-heading">{{heading}}</h4>
    </div>
    <div class="drawer-title-actions">
      <ng-content select="[drawer-actions]"></ng-content>
    </div>
  </div>
  <div class="drawer-content">
    <ng-content></ng-content>
  </div>
</div>
